import {
  ModelArtifactType,
  Period,
  WarehouseType,
} from '@elementary/common-ui/types';
import {
  AddTestForm,
  IntegrationType,
  ConditionalOperator,
  QualityDimension,
} from './types';

export const ATLAN_API_KEY_PLACEHOLDER = 'xxxxxxxxxxxxxxxxxxxxxx';

export const NO_ASSETS_LINKED_TO_TEST_DOCS_LINK =
  'https://docs.elementary-data.com/data-tests/dbt/singular-tests#test-shows-no-assets-linked-to-this-test';

export const qualityDimensions: QualityDimension[] = [
  'completeness',
  'uniqueness',
  'freshness',
  'validity',
  'accuracy',
  'consistency',
];

export const conditionalOperators: ConditionalOperator[] = [
  '>',
  '<',
  '=',
  '>=',
  '<=',
  '!=',
];

export const alertIntegrationLabel: Record<IntegrationType, string> = {
  slack: 'Slack',
  pager_duty: 'Pager Duty',
  microsoft_teams: 'Microsoft Teams',
  microsoft_teams_bot: 'Microsoft Teams (app)',
  opsgenie: 'Opsgenie',
  incident_io: 'incident.io',
  rootly: 'Rootly',
  email: 'Email',
};

export const anomalyDirectionOptions = [
  { value: 'BOTH', label: 'spikes and drops' },
  { value: 'DROP', label: 'only drops' },
  { value: 'SPIKE', label: 'only spikes' },
];

export const detectionPeriodOptions = [
  { value: 'hour', label: 'hours' },
  { value: 'day', label: 'days' },
];

export const DEFAULT_FAILURE_GRACE: Period = { count: 2, period: 'hour' };

export const EDITABLE_ASSET_TYPES = ['model', 'source'];

export const EMPTY_GROUP_TITLE = 'N/A';

export const MODEL_RUNS_ARTIFACT_TYPES: ModelArtifactType[] = [
  'model',
  'snapshot',
];

export const AutomatedTestSeverities = {
  ERROR: 10,
  WARN: 1,
};

export const CLOUD_TESTS_UNSUPPORTED_WAREHOUSES: WarehouseType[] = [
  'postgres',
  'clickhouse',
  'fabric',
];

export const CLOUD_TESTS_PARTIAL_SUPPORT_WAREHOUSES: WarehouseType[] = [
  'athena',
  'dremio',
];

export const sensitivityOptions = [
  { value: 'low', label: 'Low' },
  { value: 'medium', label: 'Medium' },
  { value: 'high', label: 'High' },
];

export const trainingPeriodOptions = [
  { value: 'day', label: 'days' },
  { value: 'week', label: 'weeks' },
  { value: 'month', label: 'months' },
];

export const getTimeBucketUnitOptions = (warehouseType?: WarehouseType) => [
  { value: 'hour', label: 'hours' },
  { value: 'day', label: 'days' },
  { value: 'week', label: 'weeks' },
  ...(warehouseType === 'redshift'
    ? []
    : [{ value: 'month', label: 'months' }]),
];

export const ANOMALY_TIME_WINDOW_DEFAULTS: Pick<
  AddTestForm,
  | 'detectionPeriod'
  | 'detectionUnit'
  | 'trainingPeriodCount'
  | 'trainingPeriodUnit'
> = {
  detectionPeriod: 1,
  detectionUnit: 'day',
  trainingPeriodCount: 14,
  trainingPeriodUnit: 'day',
};

export const pipelineThresholdUnitOptions = [
  { value: 'second', label: 'seconds' },
  { value: 'minute', label: 'minutes' },
  { value: 'hour', label: 'hours' },
];

export const TRAINING_PERIOD_LIMITS: Record<
  string,
  { min: number; max: number }
> = {
  day: { min: 7, max: 90 },
  week: { min: 1, max: 12 },
  month: { min: 1, max: 3 },
};
